import React, { useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { resetUserPassword } from '../../apis/services';

const ResetPassword = (props) => {
    const { t } = useTranslation();
    const [password, setPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();
    const [loading, setLoading] = useState(false);
    const toast = useRef();

    const handleResetPassword = async () => {
        if (password !== confirmPassword) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: t('passwords_not_matching'), life: 3000 });
        } else {
            try {
                setLoading(true);
                let data = {
                    password: password,
                    user: props.userId
                }
                await resetUserPassword(data);
                toast.current.show({ severity: 'success', summary: 'success', detail: t('password_changed'), life: 3000 });
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.log(error);
            }


        }


    }
    return (
        <div className="glass-card p-3 mt-3">
            <Toast ref={toast} />
            <div className="row">
                <div className="">
                    <form action="" method="post"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleResetPassword();
                        }}
                    >
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="newPassword" className="mb-1 required">{t('new_password')}</label>
                                    <input type="password" className="form-control"
                                        required
                                        value={password}
                                        onChange={(e) => {
                                            setPassword(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="confPassword" className="mb-1 required">{t('confirm_password')}</label>
                                    <input type="password" className="form-control"
                                        required
                                        value={confirmPassword}
                                        onChange={(e) => {
                                            setConfirmPassword(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12 mt-3">
                                <Button label={t('reset_password')} loading={loading} />
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    );
}

export default ResetPassword;